module.exports = __webpack_public_path__ + "static/record-rosy-32a53f8e2397548cdec05efca656bb2d.png";